export default {
  myFeedbacks: null,
  ehgValues: {},
  currentFeedbackData: null,
  feedbackInProgress: false,
  feedbackId: null
};
